import Vue from "vue";
import { ILogger, LoggerFactory } from "../../../utilities/logger";
import { Route, RawLocation } from "vue-router";
import { Query } from "./Query";

type RouteDestination<V extends Vue = Vue> = RawLocation | false | ((vm: V) => any) | void;

export class Dispatcher<TQuery extends Query> {
  constructor(public readonly toQuery: (r: Route) => TQuery) {
  }

  protected get logger(): ILogger {
    return LoggerFactory.getLogger();
  }

  public async dispatch<V extends Vue = Vue>(to: Route, next: (to?: RouteDestination<V>) => void, toDestinations: ((q: TQuery) => Promise<RouteDestination<V>>) | (((q: TQuery) => Promise<RouteDestination<V>>)[])): Promise<void> {
    if (await this.redirect(to, next, toDestinations)) {
      return;
    }
    next(); // リダイレクト先が指定されなかったので予定していた遷移先へ.
  }

  public async redirect<V extends Vue = Vue>(to: Route, next: (to?: RouteDestination<V>) => void, toDestinations: ((q: TQuery) => Promise<RouteDestination<V>>) | (((q: TQuery) => Promise<RouteDestination<V>>)[])): Promise<boolean> {
    if (!Array.isArray(toDestinations)) {
      return this.redirect(to, next, [ toDestinations ]);
    }
    try {
      for (const toDestination of toDestinations) {
        const destination = await toDestination(this.toQuery(to));
        if ((destination !== undefined) && (destination !== null)) {
          next(destination);
          return true;
        }
      }
      return false;
    } catch (e) {
      next(this.toError(to, e.toString()));
      return true;
    }
  }

  protected toError(to: Route, message: string): RawLocation {
    return {
      path: "/Error",
      query: {
        url: to.fullPath,
        message,
      }
    };
  }

  protected toWarning(to: Route, message: string): RawLocation {
    return {
      path: "/Warning",
      query: {
        url: to.fullPath,
        message,
      }
    };
  }

  protected toConfirm(title: string, message: string, actionButtonName: string, cancelButtonName: string, destination: string): RawLocation {
    return {
      path: "/Confirm",
      query: {
        title: title,
        message: message,
        actionButtonName: actionButtonName,
        cancelButtonName: cancelButtonName,
        destination: destination,
      }
    };
  }
}
